import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CleaningContent from '../components/CleaningContent';

const DentalCleaning = () => {
  return (
    <div className="exams-and-cleanings-container" style={{ backgroundColor: "#edffee" }}>
      <Header />
      <CleaningContent />
      <Footer />
    </div>
  );
};

export default DentalCleaning;